// Full IT / EN dictionaries for AZ Mechanical Design Studio
// Italian first, then English (user preference).

export const TRANSLATIONS = {
  it: {
    nav: {
      home: "Home",
      about: "Studio",
      services: "Servizi",
      industries: "Settori",
      portfolio: "Portfolio",
      process: "Processo",
      contact: "Contatti",
      cta: "Contatta lo studio",
    },
    common: {
      studio: "AZ Mechanical Design Studio",
      founder: "Antonio Zaccaria",
      role: "Mechanical Engineering & CAD Design Partner",
      viewProject: "Vedi",
      readMore: "Approfondisci",
      allRights: "Tutti i diritti riservati.",
      backTop: "Torna su",
      chapter: "Capitolo",
      section: "Sezione",
      based: "Con base in Svizzera — operativo worldwide",
      email: "info@azstudio.ch",
      phone: "+41 (0)76 534 22 40",
      phoneLabel: "Telefono diretto",
    },
    marquee: [
      "Precisione ingegneristica",
      "Sviluppo CAD",
      "Automazione industriale",
      "Reverse engineering",
      "Documentazione tecnica",
      "Progettazione meccanica",
    ],
    home: {
      heroKicker: "AZ — Studio di progettazione meccanica",
      heroTitle: ["Soluzioni di", "progettazione meccanica", "per sfide", "ingegneristiche complesse."],
      heroSub: "Supporto CAD ingegneristico esterno per aziende, produttori e innovatori nel mondo.",
      ctaProjects: "Vedi i progetti",
      ctaServices: "Scopri i servizi",
      ctaContact: "Contatta lo studio",
      statementKicker: "Manifesto",
      statementTitle: "Trasformiamo idee ingegneristiche in soluzioni meccaniche precise.",
      chapters: [
        {
          n: "01",
          title: "Precisione, non approssimazione.",
          body: "Ogni linea, tolleranza e assemblaggio nasce da una decisione ingegneristica motivata. Nessun modello 3D lascia lo studio senza essere completamente definito per la produzione.",
        },
        {
          n: "02",
          title: "Un partner, non un fornitore.",
          body: "Lo studio si integra come estensione del vostro reparto tecnico: comprendiamo il prodotto, dialoghiamo con officina e fornitori, garantiamo continuità sul progetto.",
        },
        {
          n: "03",
          title: "Design orientato alla produzione.",
          body: "Progettiamo pensando a chi taglia, piega, salda e assembla. Ogni componente è concepito per essere realizzato in modo efficiente, ripetibile e verificabile.",
        },
      ],
      expertiseKicker: "Competenze",
      expertiseTitle: "Un unico interlocutore per l'intero flusso di progettazione.",
      expertiseCopy: "Dall'analisi funzionale alla documentazione di produzione, lo studio copre l'intera catena tecnica con strumenti CAD professionali e metodo rigoroso.",
      stackKicker: "Stack CAD",
      servicesKicker: "Servizi",
      servicesTitle: "Un servizio ingegneristico completo.",
      servicesCta: "Tutti i servizi",
      industriesKicker: "Settori serviti",
      industriesTitle: "Progettazione al servizio di industrie ad alto contenuto tecnico.",
      processKicker: "Processo",
      processTitle: "Un metodo lineare, verificabile, ripetibile.",
      selectedKicker: "Progetti selezionati",
      selectedTitle: "Una selezione di lavori recenti.",
      contactKicker: "Contatto",
      contactTitle: "Parliamo del vostro prossimo progetto meccanico.",
      contactCopy: "Descrivete brevemente l'esigenza tecnica: risponderemo con un'analisi preliminare e i passi successivi.",
    },
    about: {
      kicker: "Studio",
      title: "AZ Mechanical Design Studio.",
      lead: "Uno studio di progettazione meccanica fondato da Antonio Zaccaria, dedicato ad aziende, produttori e innovatori che richiedono supporto ingegneristico esterno di livello industriale.",
      bio1: "Lo studio nasce dall'esigenza di offrire alle aziende un partner tecnico affidabile per la progettazione meccanica, il modellazione CAD e la documentazione di produzione. Ogni progetto è affrontato con il rigore di un reparto R&D interno.",
      bio2: "L'esperienza operativa comprende macchinari industriali, strutture saldate, carpenteria in lamiera, componenti meccanici complessi, tettoie e passerelle industriali, documentazione tecnica per la produzione, reverse engineering di parti esistenti, sviluppo prodotto dalla concept alle tavole 2D e progettazione secondo il sistema BIM.",
      bio3: "L'obiettivo non è consegnare un file, ma consegnare un progetto pronto per la produzione, con scelte motivate, tolleranze coerenti e disegni comprensibili in officina. Quando serve, il cliente può appoggiarsi anche a una rete di officine e produttori selezionati, coordinati dallo studio.",
      valuesKicker: "Principi",
      values: [
        { t: "Rigore tecnico", d: "Ogni decisione progettuale è tracciabile, motivata, coerente con il contesto produttivo." },
        { t: "Riservatezza", d: "NDA su richiesta. Tutti i file, i modelli e le informazioni ricevute restano confidenziali." },
        { t: "Continuità", d: "Un unico interlocutore per l'intero ciclo: dall'idea alle tavole di produzione." },
        { t: "Chiarezza", d: "Comunicazione tecnica precisa, deliverable definiti, tempi verificabili." },
      ],
      capabilitiesKicker: "Capacità",
      stackKicker: "Software",
      credentialsKicker: "Standard e metodo",
      credentials: [
        { t: "ISO 9001", d: "Conoscenza approfondita della norma ISO 9001: processi tracciabili, revisioni gestite, documentazione coerente con i sistemi qualità aziendali." },
        { t: "Sistema BIM", d: "Progettazione anche in ambiente BIM: modello informativo, coordinamento con altre discipline, esportazione per interoperabilità con studi tecnici e commesse edili-industriali." },
        { t: "Tettoie e passerelle", d: "Progettazione strutturale di tettoie industriali, coperture leggere e passerelle di servizio: dimensionamento, dettagli costruttivi e tavole per la carpenteria." },
      ],
      networkKicker: "Rete produttiva",
      networkTitle: "Dal progetto al pezzo finito, senza cambiare interlocutore.",
      networkBody: "Su richiesta, lo studio si appoggia a una rete selezionata di officine meccaniche, carpenterie e fornitori specializzati per il taglio laser, la piegatura, la saldatura e la lavorazione meccanica. Il cliente riceve non solo il progetto, ma anche l'accesso a produttori già validati.",
    },
    services: {
      kicker: "Servizi",
      title: "Un servizio ingegneristico completo, dalla concept alla produzione.",
      lead: "Ogni servizio nasce da un problema tecnico reale. Di seguito il percorso: problema del cliente, soluzione ingegneristica, risultato consegnato.",
      pcs: { problem: "Problema", solution: "Soluzione", result: "Risultato" },
      items: {
        "mechanical-design": {
          title: "Progettazione meccanica",
          problem: "L'azienda ha un requisito funzionale ma non ha risorse ingegneristiche interne per tradurlo in un progetto completo.",
          solution: "Analisi dei requisiti, studio funzionale, dimensionamento dei componenti, scelta materiali e sviluppo del complessivo meccanico.",
          result: "Un progetto meccanico coerente, dimensionato, verificato e pronto per essere modellato in CAD 3D.",
        },
        "cad-3d-modeling": {
          title: "Modellazione CAD 3D",
          problem: "Serve un modello 3D parametrico, aggiornabile, adatto alla produzione e all'aggiornamento futuro.",
          solution: "Modellazione in SolidWorks / Inventor / Fusion 360 con struttura parametrica e assiemi organizzati per revisioni future.",
          result: "Modello 3D pulito, gerarchizzato, con distinta base coerente e file pronti per la messa in tavola.",
        },
        "industrial-machinery": {
          title: "Progettazione di macchinari industriali",
          problem: "Occorre progettare una macchina o una linea, integrando meccanica, movimentazione e struttura portante.",
          solution: "Progettazione completa: telaio, gruppi funzionali, movimentazione, protezioni, integrazione con componenti pneumatici e attuatori.",
          result: "Macchinario progettato completamente, con documentazione tecnica per costruttore e assemblatore.",
        },
        "sheet-metal": {
          title: "Progettazione carpenteria in lamiera",
          problem: "Servono componenti in lamiera realizzabili con taglio laser, piegatura e saldatura.",
          solution: "Progettazione sheet metal con sviluppi corretti, raggi di piega coerenti con lo spessore, tolleranze compatibili con la lavorazione.",
          result: "Tavole di produzione con sviluppi, quote critiche e note di lavorazione pronte per l'officina.",
        },
        "welded-structures": {
          title: "Strutture saldate, tettoie e passerelle",
          problem: "È necessaria una struttura portante saldata, una tettoia industriale o una passerella di servizio, verificata e con distinta di taglio ottimizzata.",
          solution: "Progettazione con weldment: telai, tettoie, coperture leggere e passerelle. Gestione dei profilati, definizione dei cordoni di saldatura, dettagli costruttivi e sequenze di montaggio.",
          result: "Complessivo saldato con tavole delle sottoparti, distinta di taglio e schemi di saldatura chiari, pronto per la carpenteria.",
        },
        "technical-drawings": {
          title: "Documentazione tecnica",
          problem: "I modelli 3D esistono ma mancano le tavole 2D di qualità per andare in produzione.",
          solution: "Realizzazione di tavole tecniche complete: quotature, tolleranze GD&T, sezioni, viste ausiliarie, note di lavorazione.",
          result: "Documentazione 2D chiara, uniforme, comprensibile in officina, coerente con lo standard aziendale.",
        },
        "reverse-engineering": {
          title: "Reverse engineering",
          problem: "Esiste un componente fisico, ma non esistono più i disegni originali o non sono aggiornati.",
          solution: "Rilievo dimensionale, ricostruzione del modello 3D parametrico e generazione della documentazione 2D.",
          result: "Componente digitalizzato, replicabile, modificabile e integrabile in nuove revisioni.",
        },
        "product-development": {
          title: "Sviluppo prodotto",
          problem: "Un'idea, un prototipo o un requisito di mercato necessitano di essere trasformati in un prodotto industrializzabile.",
          solution: "Concept design, studio di fattibilità, sviluppo CAD, iterazioni con prototipo, industrializzazione.",
          result: "Prodotto pronto alla produzione, con documentazione completa e ottimizzato per costi e assemblaggio.",
        },
        "equipment-improvements": {
          title: "Miglioramento macchinari esistenti",
          problem: "Un macchinario esistente presenta limiti di prestazioni, sicurezza o usura.",
          solution: "Analisi tecnica, individuazione dei punti critici, riprogettazione mirata dei gruppi funzionali.",
          result: "Macchina più affidabile, sicura e performante, con documentazione aggiornata.",
        },
        "external-support": {
          title: "Supporto ingegneristico esterno",
          problem: "Il reparto tecnico interno è saturo o mancano competenze specifiche per un progetto; talvolta serve anche un partner produttivo affidabile.",
          solution: "Integrazione dello studio come reparto tecnico esterno, con report periodici, allineamento continuo e — su richiesta — coordinamento con officine e fornitori selezionati per la produzione.",
          result: "Continuità progettuale, rispetto delle scadenze, riduzione del carico sul team interno e, se necessario, un percorso end-to-end fino al pezzo finito.",
        },
      },
    },
    industries: {
      kicker: "Settori serviti",
      title: "Industrie ad alto contenuto tecnico.",
      lead: "Lo studio opera trasversalmente su settori nei quali la qualità del progetto meccanico è un fattore competitivo diretto.",
      items: {
        "industrial-machinery": {
          title: "Macchinari industriali",
          body: "Progettazione di macchine complete, gruppi funzionali, telai, movimentazioni e integrazioni meccaniche complesse.",
        },
        "automation": {
          title: "Automazione",
          body: "Supporto meccanico per stazioni automatizzate, celle robotizzate, sistemi di trasporto e integrazione di componenti standard.",
        },
        "manufacturing": {
          title: "Produzione",
          body: "Sviluppo di componenti industrializzabili con attenzione a materiali, lavorazioni e ottimizzazione dei costi produttivi.",
        },
        "metal-fabrication": {
          title: "Carpenteria metallica",
          body: "Strutture saldate, lamiera, profilati e componenti pronti per taglio laser, piegatura e saldatura.",
        },
        "product-development": {
          title: "Sviluppo prodotto",
          body: "Dalla concept al prodotto industrializzato: fattibilità, CAD, prototipazione e documentazione tecnica.",
        },
        "special-equipment": {
          title: "Attrezzature speciali",
          body: "Progettazione di attrezzature dedicate, banchi prova, dime di assemblaggio e soluzioni su misura.",
        },
      },
    },
    portfolio: {
      kicker: "Portfolio",
      title: "Progetti selezionati.",
      lead: "Una selezione di lavori recenti che esprimono il metodo dello studio: rigore, chiarezza, orientamento alla produzione.",
      filterAll: "Tutti",
      categories: {
        all: "Tutti",
        machinery: "Macchinari",
        components: "Componenti meccanici",
        assemblies: "Complessivi",
        "sheet-metal": "Strutture in lamiera",
        concept: "Sviluppo concept",
      },
      cards: {
        p01: {
          title: "Cella di lavorazione automatizzata",
          challenge: "Integrare movimentazione, protezioni e stazione di lavoro in uno spazio ridotto.",
          approach: "Layout parametrico, telaio saldato, protezioni modulari, verifica ingombri in assieme.",
          result: "Cella compatta, sicura e installabile senza modifiche in officina.",
        },
        p02: {
          title: "Componente meccanico di precisione",
          challenge: "Sostituire un componente esistente ottimizzandone peso e costo di produzione.",
          approach: "Reverse engineering del componente, ridisegno con feature ottimizzate per fresatura CNC.",
          result: "-22% peso, -18% costo di produzione a parità di prestazioni.",
        },
        p03: {
          title: "Complessivo meccanico multi-gruppo",
          challenge: "Coordinare oltre 200 componenti in un assieme coerente e producibile.",
          approach: "Struttura di assieme gerarchica, distinta base pulita, tavole di sottoassieme.",
          result: "Assemblaggio in officina eseguito senza rework, distinta senza errori.",
        },
        p04: {
          title: "Struttura in lamiera piegata",
          challenge: "Realizzare un carter tecnico complesso con taglio laser e piegatura.",
          approach: "Sviluppi corretti, raggi coerenti con lo spessore, tavole con note chiare per l'officina.",
          result: "Pezzi realizzati alla prima tornata, senza modifiche di piega.",
        },
        p05: {
          title: "Concept per nuovo prodotto industriale",
          challenge: "Trasformare un'idea in un concept ingegneristicamente sostenibile.",
          approach: "Studio di fattibilità, modello 3D di concept, valutazione di soluzioni alternative.",
          result: "Concept validato, pronto per la fase di sviluppo dettagliato.",
        },
        p06: {
          title: "Macchinario personalizzato per linea produttiva",
          challenge: "Sostituire un'operazione manuale con un macchinario dedicato.",
          approach: "Analisi del ciclo, progettazione del gruppo funzionale, integrazione con la linea esistente.",
          result: "Ciclo automatizzato con incremento della ripetibilità e riduzione dei fermi.",
        },
      },
      labels: { challenge: "Sfida", approach: "Approccio", result: "Risultato" },
    },
    process: {
      kicker: "Processo",
      title: "Un metodo lineare, verificabile, ripetibile.",
      lead: "Ogni progetto segue cinque passi definiti: nessuna zona grigia, deliverable chiari, allineamento continuo.",
      steps: {
        understanding: {
          title: "Comprensione del progetto",
          body: "Analisi dei requisiti tecnici, dei vincoli produttivi e degli obiettivi funzionali. Definizione del perimetro e del deliverable.",
        },
        concept: {
          title: "Concept e fattibilità",
          body: "Studio delle soluzioni possibili, valutazione tecnico-produttiva, scelta della direzione progettuale più solida.",
        },
        cad: {
          title: "Sviluppo CAD 3D",
          body: "Modellazione parametrica del progetto: componenti, assiemi, verifiche di ingombro e coerenza dimensionale.",
        },
        docs: {
          title: "Documentazione tecnica",
          body: "Realizzazione di tavole 2D, quotature, tolleranze GD&T, distinte base e note di lavorazione per la produzione.",
        },
        production: {
          title: "Supporto alla produzione",
          body: "Interfaccia tecnica con officina e fornitori: revisioni, chiarimenti, adattamenti, gestione delle modifiche.",
        },
      },
    },
    contact: {
      kicker: "Contatto",
      title: "Parliamo del vostro prossimo progetto meccanico.",
      lead: "Compilate il modulo con una breve descrizione tecnica del progetto. Verrete ricontattati direttamente con un'analisi preliminare.",
      name: "Nome e cognome",
      company: "Azienda",
      email: "Email professionale",
      description: "Descrizione del progetto",
      descriptionHint: "Contesto, obiettivi, vincoli tecnici, tempistica se disponibile.",
      file: "Allegato tecnico (opzionale)",
      fileHint: "PDF, disegni, riferimenti — max 20 MB",
      submit: "Invia richiesta",
      submitting: "Invio in corso…",
      success: "Grazie. La richiesta è stata inviata. Riceverete un riscontro a breve.",
      error: "Si è verificato un errore. Verificate i campi e riprovate.",
      requiredMark: "Obbligatorio",
      directEmailLabel: "Contatto diretto",
    },
    footer: {
      studioLine: "Studio di progettazione meccanica",
      builtWith: "Progettato con precisione.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "Studio",
      services: "Services",
      industries: "Industries",
      portfolio: "Portfolio",
      process: "Process",
      contact: "Contact",
      cta: "Contact studio",
    },
    common: {
      studio: "AZ Mechanical Design Studio",
      founder: "Antonio Zaccaria",
      role: "Mechanical Engineering & CAD Design Partner",
      viewProject: "View",
      readMore: "Read more",
      allRights: "All rights reserved.",
      backTop: "Back to top",
      chapter: "Chapter",
      section: "Section",
      based: "Based in Switzerland — operating worldwide",
      email: "info@azstudio.ch",
      phone: "+41 (0)76 534 22 40",
      phoneLabel: "Direct phone",
    },
    marquee: [
      "Precision engineering",
      "CAD development",
      "Industrial automation",
      "Reverse engineering",
      "Technical documentation",
      "Mechanical design",
    ],
    home: {
      heroKicker: "AZ — Mechanical Design Studio",
      heroTitle: ["Mechanical", "design solutions", "for complex", "engineering challenges."],
      heroSub: "External CAD engineering support for companies, manufacturers and innovators worldwide.",
      ctaProjects: "View projects",
      ctaServices: "Explore services",
      ctaContact: "Contact studio",
      statementKicker: "Manifesto",
      statementTitle: "Transforming engineering ideas into precise mechanical solutions.",
      chapters: [
        {
          n: "01",
          title: "Precision, not approximation.",
          body: "Every line, tolerance and assembly is the result of a motivated engineering decision. No 3D model leaves the studio without being fully defined for production.",
        },
        {
          n: "02",
          title: "A partner, not a supplier.",
          body: "The studio integrates as an extension of your engineering team: we understand the product, speak with workshops and vendors, guarantee continuity on the project.",
        },
        {
          n: "03",
          title: "Design driven by production.",
          body: "We design thinking about who cuts, bends, welds and assembles. Every component is conceived to be manufactured efficiently, repeatably and verifiably.",
        },
      ],
      expertiseKicker: "Expertise",
      expertiseTitle: "A single interlocutor for the entire design workflow.",
      expertiseCopy: "From functional analysis to production documentation, the studio covers the whole technical chain with professional CAD tools and rigorous method.",
      stackKicker: "CAD stack",
      servicesKicker: "Services",
      servicesTitle: "A complete engineering service.",
      servicesCta: "All services",
      industriesKicker: "Industries served",
      industriesTitle: "Design for industries where precision matters.",
      processKicker: "Process",
      processTitle: "A linear, verifiable, repeatable method.",
      selectedKicker: "Selected projects",
      selectedTitle: "A selection of recent work.",
      contactKicker: "Contact",
      contactTitle: "Let's talk about your next mechanical project.",
      contactCopy: "Briefly describe the technical need: we'll respond with a preliminary analysis and next steps.",
    },
    about: {
      kicker: "Studio",
      title: "AZ Mechanical Design Studio.",
      lead: "A mechanical engineering studio founded by Antonio Zaccaria, dedicated to companies, manufacturers and innovators requiring external engineering support at industrial level.",
      bio1: "The studio was born to give companies a reliable technical partner for mechanical design, CAD modeling and production documentation. Every project is approached with the rigor of an in-house R&D department.",
      bio2: "Operational experience covers industrial machinery, welded structures, sheet metal fabrication, complex mechanical components, industrial canopies and walkways, production-ready technical documentation, reverse engineering of existing parts, product development from concept to 2D drawings, and design within a BIM workflow.",
      bio3: "The goal is not to deliver a file, but to deliver a project ready for production, with motivated choices, coherent tolerances and drawings that are actually understandable on the shop floor. When needed, the client can also rely on a curated network of workshops and manufacturers coordinated by the studio.",
      valuesKicker: "Principles",
      values: [
        { t: "Technical rigor", d: "Every design decision is traceable, motivated, coherent with the production context." },
        { t: "Confidentiality", d: "NDA on request. All received files, models and information remain strictly confidential." },
        { t: "Continuity", d: "A single point of contact for the entire cycle: from idea to production drawings." },
        { t: "Clarity", d: "Precise technical communication, defined deliverables, verifiable timelines." },
      ],
      capabilitiesKicker: "Capabilities",
      stackKicker: "Software",
      credentialsKicker: "Standards & method",
      credentials: [
        { t: "ISO 9001", d: "In-depth knowledge of the ISO 9001 standard: traceable processes, managed revisions, documentation aligned with corporate quality systems." },
        { t: "BIM workflow", d: "Design also within a BIM environment: information model, coordination with other disciplines, export for interoperability with engineering firms and industrial-construction projects." },
        { t: "Canopies & walkways", d: "Structural design of industrial canopies, light roofing systems and service walkways: sizing, construction details and drawings for the fabrication workshop." },
      ],
      networkKicker: "Production network",
      networkTitle: "From project to finished part, without changing point of contact.",
      networkBody: "On request, the studio relies on a curated network of mechanical workshops, metal fabricators and specialized vendors for laser cutting, bending, welding and machining. Clients get not just the design, but access to already-validated manufacturers.",
    },
    services: {
      kicker: "Services",
      title: "A complete engineering service, from concept to production.",
      lead: "Every service starts from a real technical problem. Below the path: client problem, engineering solution, delivered result.",
      pcs: { problem: "Problem", solution: "Solution", result: "Result" },
      items: {
        "mechanical-design": {
          title: "Mechanical design",
          problem: "The company has a functional requirement but no internal engineering resources to translate it into a complete project.",
          solution: "Requirements analysis, functional study, component sizing, material selection and development of the mechanical assembly.",
          result: "A coherent mechanical project, sized, verified and ready to be modeled in 3D CAD.",
        },
        "cad-3d-modeling": {
          title: "CAD 3D modeling",
          problem: "A parametric, updatable 3D model is needed, suitable for production and future revisions.",
          solution: "Modeling in SolidWorks / Inventor / Fusion 360 with a parametric structure and assemblies organized for future revisions.",
          result: "A clean, hierarchical 3D model with coherent BOM and files ready for drawing release.",
        },
        "industrial-machinery": {
          title: "Industrial machinery design",
          problem: "A machine or line has to be designed, integrating mechanics, motion and load-bearing structure.",
          solution: "Full design: frame, functional groups, motion, guards, integration with pneumatic components and actuators.",
          result: "Machinery fully designed, with technical documentation ready for builder and assembler.",
        },
        "sheet-metal": {
          title: "Sheet metal design",
          problem: "Sheet metal components must be manufacturable via laser cutting, bending and welding.",
          solution: "Sheet metal modeling with correct flat patterns, bend radii coherent with thickness, tolerances compatible with the process.",
          result: "Production drawings with flat patterns, critical dimensions and manufacturing notes ready for the workshop.",
        },
        "welded-structures": {
          title: "Welded structures, canopies & walkways",
          problem: "A verified welded load-bearing structure, an industrial canopy or a service walkway is needed, with optimized cut list.",
          solution: "Weldment design: frames, canopies, light roofing systems and walkways. Profile management, weld bead definition, construction details and assembly sequence.",
          result: "Welded assembly with sub-part drawings, cut list and clear welding schemes, ready for the fabrication workshop.",
        },
        "technical-drawings": {
          title: "Technical drawings",
          problem: "3D models exist but production-quality 2D drawings are missing.",
          solution: "Full technical drawings: dimensioning, GD&T, sections, auxiliary views, manufacturing notes.",
          result: "Clean, uniform 2D documentation, understandable on the shop floor and consistent with company standards.",
        },
        "reverse-engineering": {
          title: "Reverse engineering",
          problem: "A physical part exists, but original drawings are missing or outdated.",
          solution: "Dimensional survey, parametric 3D reconstruction and generation of 2D documentation.",
          result: "Fully digitized part, replicable, modifiable and ready to be integrated into new revisions.",
        },
        "product-development": {
          title: "Product development",
          problem: "An idea, prototype or market requirement must be turned into an industrializable product.",
          solution: "Concept design, feasibility study, CAD development, prototype iterations, industrialization.",
          result: "Production-ready product with complete documentation, optimized for cost and assembly.",
        },
        "equipment-improvements": {
          title: "Existing equipment improvements",
          problem: "An existing machine has performance, safety or wear limitations.",
          solution: "Technical analysis, identification of critical points, targeted redesign of functional groups.",
          result: "A more reliable, safer, better-performing machine, with updated documentation.",
        },
        "external-support": {
          title: "External engineering support",
          problem: "The internal engineering team is saturated or lacks specific competences for a project; sometimes a reliable production partner is also needed.",
          solution: "Integration of the studio as an external engineering department, with periodic reports, continuous alignment and — on request — coordination with curated workshops and vendors for production.",
          result: "Project continuity, respected deadlines, reduced load on the internal team and, when needed, an end-to-end path all the way to the finished part.",
        },
      },
    },
    industries: {
      kicker: "Industries served",
      title: "Industries with high technical content.",
      lead: "The studio operates across sectors where the quality of mechanical design is a direct competitive factor.",
      items: {
        "industrial-machinery": {
          title: "Industrial machinery",
          body: "Design of complete machines, functional groups, frames, motion systems and complex mechanical integrations.",
        },
        "automation": {
          title: "Automation",
          body: "Mechanical support for automated stations, robotic cells, transport systems and standard component integration.",
        },
        "manufacturing": {
          title: "Manufacturing",
          body: "Development of industrializable components with attention to materials, processes and production cost optimization.",
        },
        "metal-fabrication": {
          title: "Metal fabrication",
          body: "Welded structures, sheet metal, profiles and components ready for laser cutting, bending and welding.",
        },
        "product-development": {
          title: "Product development",
          body: "From concept to industrialized product: feasibility, CAD, prototyping and technical documentation.",
        },
        "special-equipment": {
          title: "Special equipment",
          body: "Design of dedicated equipment, test benches, assembly jigs and tailor-made solutions.",
        },
      },
    },
    portfolio: {
      kicker: "Portfolio",
      title: "Selected projects.",
      lead: "A selection of recent work that expresses the studio's method: rigor, clarity, production orientation.",
      filterAll: "All",
      categories: {
        all: "All",
        machinery: "Machinery",
        components: "Mechanical components",
        assemblies: "Assemblies",
        "sheet-metal": "Sheet metal structures",
        concept: "Concept development",
      },
      cards: {
        p01: {
          title: "Automated processing cell",
          challenge: "Integrate motion, guards and workstation into a reduced footprint.",
          approach: "Parametric layout, welded frame, modular guards, envelope verification at assembly level.",
          result: "Compact, safe cell, installable without workshop modifications.",
        },
        p02: {
          title: "Precision mechanical component",
          challenge: "Replace an existing part optimizing weight and production cost.",
          approach: "Reverse engineering of the part, redesign with features optimized for CNC milling.",
          result: "-22% weight, -18% production cost with unchanged performance.",
        },
        p03: {
          title: "Multi-group mechanical assembly",
          challenge: "Coordinate 200+ components into a coherent, producible assembly.",
          approach: "Hierarchical assembly structure, clean BOM, sub-assembly drawings.",
          result: "Shop-floor assembly executed with no rework, error-free BOM.",
        },
        p04: {
          title: "Folded sheet metal structure",
          challenge: "Manufacture a complex technical enclosure via laser cutting and bending.",
          approach: "Correct flat patterns, radii coherent with thickness, drawings with clear notes.",
          result: "Parts manufactured first-time-right, no bending corrections needed.",
        },
        p05: {
          title: "Concept for a new industrial product",
          challenge: "Turn an idea into an engineering-sound concept.",
          approach: "Feasibility study, concept 3D model, evaluation of alternative solutions.",
          result: "Validated concept, ready for detailed design phase.",
        },
        p06: {
          title: "Custom machine for a production line",
          challenge: "Replace a manual operation with dedicated machinery.",
          approach: "Cycle analysis, design of the functional group, integration with the existing line.",
          result: "Automated cycle with improved repeatability and reduced downtime.",
        },
      },
      labels: { challenge: "Challenge", approach: "Approach", result: "Result" },
    },
    process: {
      kicker: "Process",
      title: "A linear, verifiable, repeatable method.",
      lead: "Every project follows five defined steps: no gray areas, clear deliverables, continuous alignment.",
      steps: {
        understanding: {
          title: "Project understanding",
          body: "Analysis of technical requirements, production constraints and functional objectives. Definition of scope and deliverable.",
        },
        concept: {
          title: "Concept and feasibility",
          body: "Study of possible solutions, technical-production evaluation, selection of the most solid design direction.",
        },
        cad: {
          title: "3D CAD development",
          body: "Parametric modeling of the project: components, assemblies, envelope checks and dimensional coherence.",
        },
        docs: {
          title: "Technical documentation",
          body: "2D drawings, dimensioning, GD&T tolerances, BOMs and manufacturing notes for production.",
        },
        production: {
          title: "Production support",
          body: "Technical interface with workshop and suppliers: revisions, clarifications, adaptations, change management.",
        },
      },
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk about your next mechanical project.",
      lead: "Fill out the form with a short technical description of the project. You'll be contacted directly with a preliminary analysis.",
      name: "Full name",
      company: "Company",
      email: "Business email",
      description: "Project description",
      descriptionHint: "Context, objectives, technical constraints, timeline if available.",
      file: "Technical attachment (optional)",
      fileHint: "PDF, drawings, references — max 20 MB",
      submit: "Send request",
      submitting: "Sending…",
      success: "Thank you. Your request has been sent. You'll receive a reply shortly.",
      error: "Something went wrong. Please check the fields and try again.",
      requiredMark: "Required",
      directEmailLabel: "Direct contact",
    },
    footer: {
      studioLine: "Mechanical design studio",
      builtWith: "Designed with precision.",
    },
  },
};

export const LANGUAGES = ["it", "en"];

export const CATEGORY_LABEL = (t, cat) => t.portfolio.categories[cat] ?? cat;
